// extracted by mini-css-extract-plugin
module.exports = {"urlColumn":"WebhookEndpointRow-urlColumn-0fc16975bf2b810bc4f5a920fe5dfb2b","detailsButton":"WebhookEndpointRow-detailsButton-b4aff51ecd00ebae5acb9e3aea6abb9d"};